module.exports = __webpack_public_path__ + "img/game-start-symbol.9d4c56c8.svg";